var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"iv-header"},[_c('Row',{attrs:{"class-name":"iv-main-width"}},[_c('Col',{attrs:{"span":16,"class-name":"iv-fs-24 iv-fc-85 iv-header-title iv-flex"}},[_c('span',[_c('img',{staticStyle:{"height":"44px"},attrs:{"src":require("@/assets/images/index-logo.png")}})])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }